"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorReplaceCarPriceWidget = void 0;
var React = require("react");
var FalconQuestionWidgetBase_1 = require("../../FalconQuestionWidgetBase");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("../../../commonFunctions");
var AnnualMotorReplaceCarPriceWidget = exports.AnnualMotorReplaceCarPriceWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorReplaceCarPriceWidget, _super);
    function AnnualMotorReplaceCarPriceWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.setSessionValues = function () {
            var oldVehicleMake = _this.findOldVehicleProperty("make");
            var oldVehicleModel = _this.findOldVehicleProperty("model");
            var oldVehicleRegistrationNumber = _this.findOldVehicleProperty("registrationNumber");
            window.sessionStorage.setItem("oldCarVrn", oldVehicleRegistrationNumber);
            window.sessionStorage.setItem("oldCarMake", oldVehicleMake);
            window.sessionStorage.setItem("oldCarModel", oldVehicleModel);
        };
        _this.renderPanel = function (oldVehicle, newVehicle, oldinteraction) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
            var interaction = _this.props.engine.getInteraction();
            var tierChangeWording = (0, commonFunctions_1.getTierChangeWording)(interaction);
            if (((_b = (_a = _this.props.interaction) === null || _a === void 0 ? void 0 : _a.factors) === null || _b === void 0 ? void 0 : _b.premiumType) === services_1.PREMIUM_TYPE_MONTHLY &&
                ((_d = (_c = _this.props.interaction) === null || _c === void 0 ? void 0 : _c.factors) === null || _d === void 0 ? void 0 : _d.upfrontPaymentAmount) &&
                ((_f = (_e = _this.props.interaction) === null || _e === void 0 ? void 0 : _e.factors) === null || _f === void 0 ? void 0 : _f.upfrontPaymentAmount) > 0 &&
                !((_h = (_g = _this.props.interaction) === null || _g === void 0 ? void 0 : _g.uistate) === null || _h === void 0 ? void 0 : _h.vulnerableCustomer) &&
                !((_k = (_j = _this.props.interaction) === null || _j === void 0 ? void 0 : _j.uistate) === null || _k === void 0 ? void 0 : _k.payFullPrice)) {
                return (React.createElement("div", { className: "panel mb-4 policy-change-price" },
                    React.createElement("p", { className: "text-align-center font-weight-bold" },
                        (0, commonFunctions_1.getAmountToDisplay)((_m = (_l = _this.props.interaction) === null || _l === void 0 ? void 0 : _l.factors) === null || _m === void 0 ? void 0 : _m.additionalPremium),
                        " to replace ",
                        _this.getUpdateWording(oldVehicle, newVehicle),
                        " ",
                        tierChangeWording),
                    React.createElement("p", { className: "text-align-center font-weight-bold" },
                        "Pay ",
                        (0, commonFunctions_1.getAmountToDisplay)((_p = (_o = _this.props.interaction) === null || _o === void 0 ? void 0 : _o.factors) === null || _p === void 0 ? void 0 : _p.upfrontPaymentAmount),
                        " upfront now ",
                        ((_r = (_q = _this.props.interaction) === null || _q === void 0 ? void 0 : _q.factors) === null || _r === void 0 ? void 0 : _r.monthlyPaymentSpreadAmount) > 0 ?
                            "and the remaining\n                        balance of ".concat((0, commonFunctions_1.getAmountToDisplay)((_t = (_s = _this.props.interaction) === null || _s === void 0 ? void 0 : _s.factors) === null || _t === void 0 ? void 0 : _t.monthlyPaymentSpreadAmount), " by\n                        monthly payments") : ""),
                    _this.renderRenewalWording(_this.props.interaction),
                    React.createElement("p", { className: "text-align-center font-weight-light" }, "All figures include Insurance Premium Tax")));
            }
            else if (((_v = (_u = _this.props.interaction) === null || _u === void 0 ? void 0 : _u.factors) === null || _v === void 0 ? void 0 : _v.additionalPremium) && ((_x = (_w = _this.props.interaction) === null || _w === void 0 ? void 0 : _w.factors) === null || _x === void 0 ? void 0 : _x.additionalPremium) > 0) {
                return (React.createElement("div", { className: "panel mb-4 policy-change-price" },
                    React.createElement("p", { className: "text-align-center font-weight-bold" },
                        (0, commonFunctions_1.getAmountToDisplay)((_z = (_y = _this.props.interaction) === null || _y === void 0 ? void 0 : _y.factors) === null || _z === void 0 ? void 0 : _z.additionalPremium),
                        " to replace ",
                        _this.getUpdateWording(oldVehicle, newVehicle),
                        " ",
                        tierChangeWording),
                    _this.renderRenewalWording(_this.props.interaction),
                    React.createElement("p", { className: "text-align-center font-weight-light" }, "All figures include Insurance Premium Tax")));
            }
            else if (((_1 = (_0 = _this.props.interaction) === null || _0 === void 0 ? void 0 : _0.factors) === null || _1 === void 0 ? void 0 : _1.returnPremium) && ((_3 = (_2 = _this.props.interaction) === null || _2 === void 0 ? void 0 : _2.factors) === null || _3 === void 0 ? void 0 : _3.returnPremium) > 0) {
                return (React.createElement("div", { className: "panel mb-4 policy-change-price" },
                    React.createElement("p", { className: "text-align-center font-weight-bold" },
                        "You will receive ",
                        React.createElement("span", null, (0, commonFunctions_1.getAmountToDisplay)((_5 = (_4 = _this.props.interaction) === null || _4 === void 0 ? void 0 : _4.factors) === null || _5 === void 0 ? void 0 : _5.returnPremium)),
                        " pro rata refund for replacing ",
                        _this.getUpdateWording(oldVehicle, newVehicle),
                        " ",
                        tierChangeWording,
                        "The refund excludes the cost of your cover prior to the car replacement."),
                    _this.renderRenewalWording(_this.props.interaction),
                    React.createElement("p", { className: "text-align-center font-weight-light" }, "All figures include Insurance Premium Tax")));
            }
            else {
                return (React.createElement("div", { className: "panel mb-4" },
                    React.createElement("p", null,
                        "Great news! There is no extra cost for the change you made! ",
                        tierChangeWording)));
            }
        };
        _this.getUpdateWording = function (oldVehicle, newVehicle) {
            var oldVehicleElement = React.createElement(React.Fragment, null, oldVehicle === null || oldVehicle === void 0 ? void 0 :
                oldVehicle.make,
                ", ", oldVehicle === null || oldVehicle === void 0 ? void 0 :
                oldVehicle.model,
                " ",
                (oldVehicle === null || oldVehicle === void 0 ? void 0 : oldVehicle.registrationNumber) ?
                    "(".concat(oldVehicle === null || oldVehicle === void 0 ? void 0 : oldVehicle.registrationNumber, ")") : "");
            var newVehicleElement = React.createElement(React.Fragment, null, newVehicle === null || newVehicle === void 0 ? void 0 :
                newVehicle.make,
                ", ", newVehicle === null || newVehicle === void 0 ? void 0 :
                newVehicle.model,
                " ",
                (newVehicle === null || newVehicle === void 0 ? void 0 : newVehicle.registrationNumber) ?
                    "(".concat(newVehicle === null || newVehicle === void 0 ? void 0 : newVehicle.registrationNumber, ") ") : " ");
            return (React.createElement(React.Fragment, null,
                oldVehicleElement,
                " with ",
                " ",
                newVehicleElement,
                _this.state.addedDrivers.length > 0 &&
                    React.createElement("p", { className: "text-align-center font-weight-bold" },
                        " and adding additional",
                        ' ',
                        _this.state.addedDrivers.length === 1 ? 'driver' : 'drivers',
                        " ",
                        _this.state.addedDrivers,
                        " to",
                        ' ',
                        newVehicleElement),
                _this.state.removedDrivers.length > 0 &&
                    React.createElement("p", { className: "text-align-center font-weight-bold" },
                        " and removing",
                        ' ',
                        _this.state.removedDrivers.length === 1 ? 'driver' : 'drivers',
                        " ",
                        _this.state.removedDrivers)));
        };
        _this.calculateAddedAndRemovedDrivers = function () {
            var _a;
            var addedDrivers = (_a = services_1.CommonHelpers.getRemovedAndAddedDrivers(_this.props.interaction.additionalDrivers), _a.addedDrivers), removedDrivers = _a.removedDrivers;
            _this.setState({
                addedDrivers: addedDrivers,
                removedDrivers: removedDrivers
            });
        };
        _this.findOldVehicleProperty = function (propertyName) {
            return _this.state.oldInteraction.vehicles[0][propertyName];
        };
        _this.state = {
            oldInteraction: {},
            loaded: false,
            oldVehicle: {},
            newVehicle: {},
            addedDrivers: [],
            removedDrivers: []
        };
        return _this;
    }
    AnnualMotorReplaceCarPriceWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicy(this.props.interaction.agreementNumber).subscribe(function (policy) {
            _this.setState({
                oldInteraction: policy.interaction,
                loaded: true,
                oldVehicle: policy.interaction.vehicles[0],
                newVehicle: _this.props.engine.getInteraction().vehicles[0],
            }, function () {
                _this.setSessionValues();
                _this.calculateAddedAndRemovedDrivers();
            });
        });
    };
    AnnualMotorReplaceCarPriceWidget.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps !== this.props) {
            this.setState({ newVehicle: this.props.engine.getInteraction().vehicles[0] });
        }
    };
    AnnualMotorReplaceCarPriceWidget.prototype.render = function () {
        var _a, _b, _c, _d;
        var oldVehicle = (_a = this === null || this === void 0 ? void 0 : this.state) === null || _a === void 0 ? void 0 : _a.oldVehicle;
        var newVehicle = (_b = this === null || this === void 0 ? void 0 : this.state) === null || _b === void 0 ? void 0 : _b.newVehicle;
        var oldInteraction = this.state.oldInteraction;
        if (!((_d = (_c = this.state) === null || _c === void 0 ? void 0 : _c.oldInteraction) === null || _d === void 0 ? void 0 : _d.vehicles) && this.state.loaded) {
            throw Error("".concat(this.props.question.type, " widget could not find the previous vehicle"));
        }
        return this.renderPanel(oldVehicle, newVehicle, oldInteraction);
    };
    AnnualMotorReplaceCarPriceWidget.prototype.renderInputField = function () {
    };
    AnnualMotorReplaceCarPriceWidget.prototype.renderRenewalWording = function (interaction) {
        if (interaction.uistate.renewalWindow) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement("p", { className: "text-center font-weight-semi-bold mb-0" },
                        "This means your next year's renewal price will be ",
                        (0, commonFunctions_1.getAmountToDisplay)(interaction.uistate.totalRenewalAmount)))));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], AnnualMotorReplaceCarPriceWidget.prototype, "customerPortalService", void 0);
    return AnnualMotorReplaceCarPriceWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
//# sourceMappingURL=AnnualMotorReplaceCarPriceWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualMotorReplaceCarPriceWidget.js
// module id = 3174
// module chunks = 0